import { useI18n } from "../providers/I18nProvider";
import { useWidgetContext } from "../providers/WidgetProvider";
import {
  classifyPlaceBetError,
  getModalValidationErrorKey,
  getValidationErrorKey,
} from "../shared/utils/bet-slip-place-validation";
import { PlaceBetValidationError } from "../types/enums";

function resolveParams(
  error: PlaceBetValidationError,
  user: IWidgetConfig["user"],
  brand: IWidgetConfig["brand"],
  minBet: number,
  maxBet: number,
): Record<string, string | number> {
  switch (error) {
    case PlaceBetValidationError.StakeBelowMin:
      return { minBet, currency: user.currency };
    case PlaceBetValidationError.StakeAboveMax:
      return { maxBet, currency: user.currency };
    case PlaceBetValidationError.MaxSelectionsExceeded:
      return { limit: brand.selectionsLimit };
    default:
      return {};
  }
}

export function useBetSlipValidation() {
  const { config } = useWidgetContext();
  const { t } = useI18n();

  const validate = (input: ValidatePlaceBetInput): ValidationResult => {
    const currencySportsBook =
      config.brand.currencyConfigurations?.[config.user.currencyId]?.sportsBook;
    const minBet = currencySportsBook?.minBet ?? config.user.minBet;
    const maxBet = currencySportsBook?.maxBet ?? config.user.maxBet;
    const resolvedUser = { ...config.user, minBet, maxBet };

    const error = classifyPlaceBetError({
      ...input,
      user: resolvedUser,
      brand: config.brand,
    });

    const key = getValidationErrorKey(error);
    if (key) {
      const params = resolveParams(error, config.user, config.brand, minBet, maxBet);
      return { inlineError: t(key, params), modalErrorKey: null };
    }

    const modalKey = getModalValidationErrorKey(error);
    return { inlineError: null, modalErrorKey: modalKey ?? null };
  };

  return { validate };
}
